module.exports = __webpack_public_path__ + "img/img3.52f2477f.jpg";